import { useMemo } from 'react';

interface ChildFormData {
  firstName: string;
  lastName: string;
  middleName: string;
  dateOfBirthUtc: Date | null;
}

interface UseAddChildModalProps {
  childFormData: ChildFormData;
  childFormErrors: string[];
}

export const useAddChildModal = ({ childFormData, childFormErrors }: UseAddChildModalProps) => {
  const hasRequiredFields = useMemo(() => {
    return Boolean(
      childFormData.firstName && childFormData.lastName && childFormData.dateOfBirthUtc
    );
  }, [childFormData.firstName, childFormData.lastName, childFormData.dateOfBirthUtc]);

  const hasFieldErrors = useMemo(() => {
    return childFormErrors.length > 0;
  }, [childFormErrors.length]);

  const canSubmit = useMemo(() => {
    return hasRequiredFields && !hasFieldErrors;
  }, [hasRequiredFields, hasFieldErrors]);

  return {
    hasRequiredFields,
    hasFieldErrors,
    canSubmit
  };
};
